import { render } from "./EventDomainSnippet.vue?vue&type=template&id=3638b25e&scoped=true"
import script from "./EventDomainSnippet.vue?vue&type=script&lang=js"
export * from "./EventDomainSnippet.vue?vue&type=script&lang=js"

import "./EventDomainSnippet.vue?vue&type=style&index=0&id=3638b25e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3638b25e"]])

export default __exports__